/**
 * Public runtime configuration. Every VITE_* value ships in the bundle, so nothing here may be a secret.
 * Dev defaults point at the local dev issuer and mock API; production builds fail closed (ConfigError screen)
 * when the authority or client id is missing instead of silently using a dev issuer.
 */
const env = import.meta.env;

const clean = (v: string | undefined): string | undefined => {
  const t = v?.trim().replace(/\/+$/, '');
  return t ? t : undefined;
};

export const config = {
  apiUrl: clean(env.VITE_API_URL) ?? 'http://localhost:8080',
  authority: clean(env.VITE_AUTH_AUTHORITY) ?? (env.DEV ? 'http://127.0.0.1:8787' : undefined),
  clientId: clean(env.VITE_AUTH_CLIENT_ID) ?? (env.DEV ? 'hangar-console-dev' : undefined),
  endSessionUrl: clean(env.VITE_AUTH_END_SESSION_URL),
  /** dev:aws only: the local sign-in page in front of the emulator's login form (scripts/login-page.mjs); unset in AWS. */
  authorizeUrl: clean(env.VITE_AUTH_AUTHORIZE_URL),
  version: __APP_VERSION__,
} as const;

/** Names of the required variables that are missing (empty when the console can start). */
export function configProblems(): string[] {
  const missing: string[] = [];
  if (!config.authority) missing.push('VITE_AUTH_AUTHORITY');
  if (!config.clientId) missing.push('VITE_AUTH_CLIENT_ID');
  return missing;
}

export const authorityHost = (): string => {
  try {
    return config.authority ? new URL(config.authority).host : '—';
  } catch {
    return config.authority ?? '—';
  }
};
